import { Typography } from '@material-ui/core'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import React from 'react'
import { TelemetryService } from 'services/Telemetry'

type Props = {
  children: React.ReactNode
  onClose: () => void
}

type State = {
  hasError: boolean
  error: Error | null
}

export class ViewerErrorBoundary extends React.Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props)
    this.state = { hasError: false, error: null }
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error,
    }
  }
  componentDidCatch(error, info) {
    console.warn(error, info)
    TelemetryService.getInstance().logError(error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <div>
            <Typography variant="body2" gutterBottom>
              {this.state.error.toString()}
            </Typography>
            <LocalizedButton
              translationKey="common:close"
              variant="outlined"
              color="primary"
              onClick={() => this.props.onClose()}
            />
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
